<template>
  <div class="ml-4 hidden p-3 md:block">
    <MobilePlanPartnerLogo :height="18" :logo />
  </div>
</template>

<script setup lang="ts">
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'

import MobilePlanPartnerLogo from '@backmarket/nuxt-layer-checkout/components/MobilePlanPartnerLogo/MobilePlanPartnerLogo.vue'

defineProps<{
  logo: NonNullable<MobilePlanOffer['partner']['logo']>
}>()
</script>
